// extracted by mini-css-extract-plugin
module.exports = {"brand":"Logo_brand__3wr6a","brandName":"Logo_brandName__1RqwQ"};